import React from 'react';
import { getApplicationLegalLine } from '../config/appMeta';

export default function AppFooter({ compact = false, style = {} }) {
  return (
    <footer
      aria-label="Application version and copyright"
      style={{
        color: '#94a3b8',
        fontSize: compact ? '0.72rem' : '0.78rem',
        lineHeight: 1.45,
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
        padding: compact ? '0.55rem 0.75rem' : '0.8rem 1rem',
        ...style,
      }}
    >
      <div>{getApplicationLegalLine()}</div>
    </footer>
  );
}
